module.exports = __webpack_public_path__ + "static/404-image-43012e4f58da386496e4dbc347117c14.png";